import * as React from 'react';

function MixedMartialArts(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.073 2.73c1.271.404 1.358 1.418.82 3.201l-.063.202-.31.964-.064.217a2.841 2.841 0 00-.095.474l-.005.086v.535l.007.241.01.19.017.146.012.069c.061-.039.129-.09.207-.158l.08-.07.088-.084c.403-.39.591-.694.734-1.128l.009-.026.01-.035.248-.883.058-.199c.154-.492.349-.98.621-1.526l.143-.278.146-.267c.198-.347.399-.648.604-.91.837-1.061 1.643-1.416 2.887-1.479l.224-.008.263-.004c1.591-.022 5.738 3.559 6.182 5.532.467 2.079-.86 5.489-2.838 7.401-1.154 1.115-3.129 2.128-5.93 3.055l-.388.126-.653.203-.27.378c-.117.163-.233.32-.346.47l-.168.221-.328.415c-1.068 1.318-1.942 2.042-2.68 2.176l-.123.017-.108.006c-1.496.02-6.095-4.207-6.074-5.634.01-.666.46-1.4 1.245-2.252l.128-.139.13-.135.273-.273.007-.007 4.186 3.693.082.065a.93.93 0 001.23-.16.855.855 0 00-.091-1.196l-4.253-3.755V12.2l.013-.105.03-.288.055-.709.09-1.443.054-.796.031-.356.033-.312.036-.26.062-.365.073-.364.11-.502.112-.473.112-.44.115-.412.118-.382.12-.354c.659-1.804 1.497-2.376 2.972-1.908z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MixedMartialArts;
